__turbopack_context__.v({
  "contentOverlay": "PromotionalBlade-module-scss-module__dUfrFa__contentOverlay",
  "contentWrapper": "PromotionalBlade-module-scss-module__dUfrFa__contentWrapper",
  "eyebrow": "PromotionalBlade-module-scss-module__dUfrFa__eyebrow",
  "promoBladeCTA": "PromotionalBlade-module-scss-module__dUfrFa__promoBladeCTA",
  "promotionalBladeContainer": "PromotionalBlade-module-scss-module__dUfrFa__promotionalBladeContainer",
  "promotionalBladeSection": "PromotionalBlade-module-scss-module__dUfrFa__promotionalBladeSection",
});
